/* global window */
/* eslint-disable prefer-template */

export function getType() {
  if (
    typeof window !== 'undefined' &&
    (window.location.host === 'prezident2018.rekonstrukcestatu.cz' ||
      window.location.host === 'p.localhost.rekonstrukcestatu.cz:8080')
  ) {
    return 'president'
  }
  return 'mop'
}

export default function load(type) {
  console.log('type:', getType())
  if (type === 'mop') return import('./mop.mjs')
  if (type === 'president') return import('./president.mjs')
  if (type) throw new Error('Unknown type ' + type)
  if (getType() === 'president') {
    return import('./president.mjs')
  }
  return import('./mop.mjs')
}



//////////////////
// WEBPACK FOOTER
// ./data/index.mjs
// module id = nCyS
// module chunks = 10